var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIFPhMgry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "white",
    stroke: "#2593FF",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.125C16.5 7.29657 15.8284 6.625 15 6.625C14.1716 6.625 13.5 7.29657 13.5 8.125H16.5ZM15 15.9659H13.5V16.7205L14.1058 17.1703L15 15.9659ZM17.8558 19.9544C18.521 20.4482 19.4605 20.3093 19.9544 19.6441C20.4482 18.979 20.3093 18.0395 19.6442 17.5456L17.8558 19.9544ZM13.5 8.125V15.9659H16.5V8.125H13.5ZM14.1058 17.1703L17.8558 19.9544L19.6442 17.5456L15.8942 14.7615L14.1058 17.1703Z",
    fill: "#2593FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIFPhMgry);
export default __webpack_public_path__ + "static/media/iFPhMgry.2e088b0e61348b79a472d81000433fce.svg";
export { ForwardRef as ReactComponent };